
export default {
  'm':{
    'collect_cards_slogan':'Collect cards to win millions of diamonds',
    'participate_event':'Participate in the event',
    'event_rule_title':'Event rules',
    'event_rule_desc':'During the event, there will be a draw for every 300 diamonds recharged, and 100% of the draw will result in a card. Users with five cards can exchange for the King Card, and those who have the King Card can divide the prize by the number of King Cards they have. Rewards will be automatically distributed at the end of the event.',
    'draws_diamonds_num':'Number of diamonds recharged',
    'available_draws':'My available draws',
    'sel_card':'Click to select a card',
    'gift_id':'Gift ID',
    'synthesis':'Synthesis',
    'gongxi_tip':'ID {msg_ss}**** synthesizes the King Card',
    'divide_countdown':'Countdown to divide the King Card Prize',
    'congra_baron':'Congratulations! Acquired Baron Card',
    'congra_viscount':'Congratulations! Acquired Viscount Card',
    'congra_earl':'Congratulations! Acquired Earl Card',
    'congra_marquis':'Congratulations! Acquired Marquis Card',
    'congra_duke':'Congratulations! Acquired Duke Card',
    'congra_king':'Congratulations! Acquired valuable King Card',
    'reward_king':'King Card Reward',
    'click_send_friend':'Click on the card and send it to friends',
    'reward_tip':'The final reward is the contribution of all participating users',
    'participated':'Participated',
    'event_finish':'Event Finished',
    'recipient_not':'Recipient does not exist',
    'baoming_canjia':'Please register before participating',
    'card_not_enough':'Not enough cards',
    'not_draws':'You have no more draws',
    'sel_a_card':'Please select a card to send',
    'send_success':'Card delivery success',
    'not_this_card':'No such card',

    'reward_delay_notice':'The event is too hot, your rewards will arrive later',
    'friend_send_nan':'{msg_ss} sent you a Baron Card',
    'friend_send_zi':'{msg_ss} sent you a Viscount Card',
    'friend_send_bo':'{msg_ss} sent you a Earl Card',
    'friend_send_hou':'{msg_ss} sent you a Marquis Card',
    'friend_send_gong':'{msg_ss} sent you a Duke Card',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js